
export const USE_JENKINS_PROPS = process.env.REACT_APP_USE_JENKINS_PROPS === 'true';

export const BASE_URL = USE_JENKINS_PROPS ? '@BASE_URL@' : process.env.REACT_APP_API_BASE_URL;

export const SERVICE_ENDPOINTS = {
  PRICE_LIST_CATEGORIES: BASE_URL + '/pricelist/categories/{lang}',
  PRICE_LIST_VERSIONS: BASE_URL + '/pricelist/versions/{lang}?mtbId={mtbId}',
  PRICE_LIST_REVISION: BASE_URL + '/pricelist/{lang}?mtbId={mtbId}&version={version}',
};
